import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Location } from '@angular/common';
import { SettingsProvider } from '@services/settings/settings';
import { CustomizedLabels } from '@models/models';
import { takeUntil } from 'rxjs/operators';

@Component({
	selector: 'event-type-row',
	template: require('./event-type-row.html')
})
export class EventTypeRowComponent implements OnInit, OnDestroy {
	@Input() eventData: any;
	@Input() snFilter: string;

	private mainShootLabelName: string;
	private extraShootLabelName: string;

	eventColor: string;
	eventType: string;
	unsubscribe: Subject<void> = new Subject();

	constructor(
		private location: Location,
		private settingsService: SettingsProvider
	) {}

	ngOnInit() {
		this.subscribeToCustomizeLabelsChange();

		if (this.eventData) {
			this.setEventType(this.eventData);
		}
	}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	isMainShoot = event => event.calendarEventType === 'MAIN_SHOOT';

	isApp = event => {
		if (event.jobId) {
			return event.calendarEventType === 'APPOINTMENT';
		}
	};

	isExtraShoot(eventData) {
		return eventData.calendarEventType === 'EXTRA_SHOOT';
	}

	showLeadJob(id, eventData, type): void {
		let redirectLink = `${type}/view/${id}`;

		if (eventData.calendarEventType === 'MAIN_SHOOT') {
			this.location.go(redirectLink);
			return;
		}

		if (eventData.taskId) {
			redirectLink = `${redirectLink}?task=${eventData.taskId}`;
			this.location.go(redirectLink);
		}
	}

	private subscribeToCustomizeLabelsChange(): void {
		this.settingsService.customizeLabelsObservable
			.pipe(takeUntil(this.unsubscribe))
			.subscribe((customizeLabels: CustomizedLabels): void => {
				this.mainShootLabelName = customizeLabels.mainShootLabel.toUpperCase();
				this.extraShootLabelName = customizeLabels.extraShootLabel.toLocaleLowerCase();
			});
	}

	private setEventType(event) {
		if (event.calendarEventType === 'MAIN_SHOOT' && event.inLead === false) {
			this.eventColor = 'SHOOT';
			this.eventType = this.mainShootLabelName;
		} else if (
			event.calendarEventType === 'MAIN_SHOOT' &&
			event.inLead === true
		) {
			this.eventColor = 'LEAD';
			this.eventType = this.mainShootLabelName;
		} else if (
			event.calendarEventType === 'EXTRA_SHOOT' &&
			event.inLead === false
		) {
			this.eventColor = 'SHOOT';
			this.eventType = this.extraShootLabelName;
		} else if (
			event.calendarEventType === 'EXTRA_SHOOT' &&
			event.inLead === true
		) {
			this.eventColor = 'LEAD';
			this.eventType = this.extraShootLabelName;
		} else {
			this.eventColor = 'APPOINTMENT';
			this.eventType = 'APPOINTMENT';
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/common/event-type-row/event-type-row.ts